/**
 * @generated SignedSource<<d21482d2ad121954f7ecf646f39a11ea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type GoalViewQuery$variables = {
  goalUpdateDraftsEnabled: boolean;
  key: string;
  trackViewEvent?: TrackViewEvent | null;
};
export type GoalViewQuery$data = {
  readonly goal: {
    readonly ari: string;
    readonly key: string;
    readonly name: string;
    readonly parentGoals: {
      readonly count: number;
    } | null;
    readonly subGoals: {
      readonly count: number;
    } | null;
    readonly uuid: string;
    readonly " $fragmentSpreads": FragmentRefs<"GoalArchivedPanel" | "GoalCompletePanel" | "GoalContent" | "useRedirectToDefaultGoalTab">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"metricInfoSectionNewLozenge">;
};
export type GoalViewQuery = {
  response: GoalViewQuery$data;
  variables: GoalViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalUpdateDraftsEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v3 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "kind": "ScalarField",
  "name": "ari"
},
v8 = {
  "kind": "ScalarField",
  "name": "count"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "concreteType": "GoalConnection",
  "kind": "LinkedField",
  "name": "parentGoals",
  "plural": false,
  "selections": (v9/*: any*/)
},
v11 = {
  "concreteType": "GoalConnection",
  "kind": "LinkedField",
  "name": "subGoals",
  "plural": false,
  "selections": (v9/*: any*/)
},
v12 = {
  "kind": "ScalarField",
  "name": "kind"
},
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "concreteType": "GoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/)
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "archived"
},
v16 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v17 = {
  "kind": "ScalarField",
  "name": "type"
},
v18 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v19 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v20 = {
  "kind": "ScalarField",
  "name": "messageId"
},
v21 = [
  (v20/*: any*/)
],
v22 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v21/*: any*/)
},
v23 = {
  "kind": "ScalarField",
  "name": "score"
},
v24 = {
  "kind": "ScalarField",
  "name": "value"
},
v25 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v22/*: any*/),
    (v24/*: any*/),
    (v23/*: any*/)
  ]
},
v26 = [
  (v19/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/)
],
v27 = {
  "concreteType": "GoalState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v26/*: any*/)
},
v28 = {
  "kind": "ScalarField",
  "name": "label"
},
v29 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v30 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v28/*: any*/),
  (v22/*: any*/),
  {
    "alias": "tooltip",
    "args": (v29/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v29/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v31 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v33 = {
  "kind": "ScalarField",
  "name": "picture"
},
v34 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v35 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/)
  ]
},
v36 = [
  (v24/*: any*/),
  (v13/*: any*/)
],
v37 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v36/*: any*/)
},
v38 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v39 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v40 = {
  "kind": "ScalarField",
  "name": "subType"
},
v41 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  },
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v42 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v43 = {
  "concreteType": "ProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "concreteType": "ProjectPhaseDetails",
          "kind": "LinkedField",
          "name": "newPhase",
          "plural": false,
          "selections": [
            {
              "alias": "_id",
              "kind": "ScalarField",
              "name": "id"
            }
          ]
        },
        {
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v32/*: any*/),
            (v35/*: any*/)
          ]
        },
        (v6/*: any*/),
        (v5/*: any*/),
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "private"
        },
        {
          "concreteType": "Icon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "kind": "ScalarField",
              "name": "shortName"
            }
          ]
        },
        {
          "concreteType": "IconURIs",
          "kind": "LinkedField",
          "name": "iconUrl",
          "plural": false,
          "selections": [
            {
              "concreteType": "ThemeURIs",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "light"
                },
                {
                  "kind": "ScalarField",
                  "name": "dark"
                },
                {
                  "kind": "ScalarField",
                  "name": "transparent"
                }
              ]
            }
          ]
        },
        (v31/*: any*/),
        {
          "concreteType": "ProjectState",
          "kind": "LinkedField",
          "name": "state",
          "plural": false,
          "selections": [
            (v28/*: any*/),
            (v22/*: any*/),
            (v24/*: any*/),
            {
              "concreteType": "CompletionProjectState",
              "kind": "LinkedField",
              "name": "atCompletionState",
              "plural": false,
              "selections": [
                (v24/*: any*/),
                (v28/*: any*/),
                (v22/*: any*/)
              ]
            }
          ]
        },
        (v15/*: any*/),
        {
          "concreteType": "UserConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "concreteType": "UserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v32/*: any*/),
                    (v13/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    (v42/*: any*/)
  ]
},
v44 = [
  (v24/*: any*/),
  (v23/*: any*/)
],
v45 = {
  "kind": "ScalarField",
  "name": "watching"
},
v46 = {
  "kind": "ScalarField",
  "name": "state"
},
v47 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v48 = [
  (v24/*: any*/)
],
v49 = {
  "kind": "InlineFragment",
  "selections": [
    (v20/*: any*/),
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "LocalizationField"
},
v50 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v47/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v48/*: any*/),
      "type": "GoalTypeCustomName"
    },
    (v49/*: any*/)
  ]
},
v51 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v47/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v48/*: any*/),
      "type": "GoalTypeCustomNamePlural"
    },
    (v49/*: any*/)
  ]
},
v52 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v13/*: any*/),
    {
      "concreteType": "WorkspaceAIConfig",
      "kind": "LinkedField",
      "name": "aiConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "enabled"
        }
      ]
    }
  ]
},
v53 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v54 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_ASC"
    ]
  }
],
v55 = {
  "kind": "ScalarField",
  "name": "time"
},
v56 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v57 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v58 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v59 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    (v58/*: any*/)
  ]
},
v60 = {
  "args": (v54/*: any*/),
  "concreteType": "MetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "MetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v24/*: any*/),
            (v55/*: any*/),
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v47/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "GoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v56/*: any*/),
                        {
                          "concreteType": "Goal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": [
                            (v13/*: any*/)
                          ]
                        },
                        {
                          "concreteType": "GoalState",
                          "kind": "LinkedField",
                          "name": "newState",
                          "plural": false,
                          "selections": (v44/*: any*/)
                        },
                        (v13/*: any*/)
                      ]
                    }
                  ],
                  "type": "FromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v56/*: any*/)
                  ],
                  "type": "FromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "FromMetricUpdate"
                }
              ]
            },
            (v13/*: any*/),
            (v47/*: any*/)
          ]
        },
        (v57/*: any*/)
      ]
    },
    (v59/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
},
v61 = {
  "args": (v54/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v62 = {
  "kind": "ScalarField",
  "name": "source"
},
v63 = [
  (v55/*: any*/),
  (v13/*: any*/)
],
v64 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v63/*: any*/)
},
v65 = {
  "kind": "ScalarField",
  "name": "end"
},
v66 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    {
      "concreteType": "TargetDateRange",
      "kind": "LinkedField",
      "name": "dateRange",
      "plural": false,
      "selections": [
        (v65/*: any*/)
      ]
    }
  ]
},
v67 = {
  "kind": "ScalarField",
  "name": "variance"
},
v68 = {
  "args": (v54/*: any*/),
  "concreteType": "MetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "MetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v63/*: any*/)
        },
        {
          "concreteType": "MetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            (v66/*: any*/),
            (v24/*: any*/)
          ]
        },
        (v67/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
},
v69 = {
  "concreteType": "MetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v36/*: any*/)
    },
    (v67/*: any*/)
  ]
},
v70 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v71 = [
  (v17/*: any*/),
  (v16/*: any*/)
],
v72 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": (v71/*: any*/)
},
v73 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v58/*: any*/)
  ]
},
v74 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v75 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v76 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v77 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v75/*: any*/),
            (v7/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v56/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v32/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v33/*: any*/),
                    (v5/*: any*/),
                    (v76/*: any*/),
                    (v34/*: any*/)
                  ]
                },
                (v13/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v42/*: any*/)
  ]
},
v78 = {
  "kind": "ScalarField",
  "name": "start"
},
v79 = [
  (v5/*: any*/)
],
v80 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v81 = {
  "kind": "ScalarField",
  "name": "summary"
},
v82 = {
  "kind": "ScalarField",
  "name": "title"
},
v83 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v82/*: any*/),
    (v81/*: any*/),
    (v13/*: any*/)
  ]
},
v84 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v85 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v86 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v87 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v88 = {
  "concreteType": "Metric",
  "kind": "LinkedField",
  "name": "metric",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v5/*: any*/),
    (v17/*: any*/),
    (v40/*: any*/),
    (v15/*: any*/),
    (v62/*: any*/),
    (v64/*: any*/)
  ]
},
v89 = [
  (v6/*: any*/),
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalViewQuery",
    "selections": [
      {
        "alias": "goal",
        "args": (v3/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "GoalArchivedPanel"
          },
          {
            "kind": "FragmentSpread",
            "name": "GoalCompletePanel"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "goalUpdateDraftsEnabled",
                "variableName": "goalUpdateDraftsEnabled"
              }
            ],
            "kind": "FragmentSpread",
            "name": "GoalContent"
          },
          {
            "kind": "FragmentSpread",
            "name": "useRedirectToDefaultGoalTab"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "metricInfoSectionNewLozenge"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalViewQuery",
    "selections": [
      {
        "alias": "goal",
        "args": (v3/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v10/*: any*/),
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "progress",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canAddLinkedProjects"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveLinkedProjects"
                          }
                        ]
                      },
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v18/*: any*/),
                      (v5/*: any*/),
                      (v27/*: any*/),
                      (v31/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v35/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v40/*: any*/),
                                      (v13/*: any*/),
                                      (v15/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "args": (v41/*: any*/),
                        "concreteType": "ProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          (v42/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": "connectionId",
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          (v13/*: any*/),
          {
            "concreteType": "GoalState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": (v44/*: any*/)
          },
          {
            "kind": "ScalarField",
            "name": "userUpdateCount"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          (v45/*: any*/),
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "concreteType": "GoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "concreteType": "GoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  (v13/*: any*/),
                  (v7/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/)
                ]
              },
              (v50/*: any*/)
            ]
          },
          {
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v13/*: any*/),
              (v7/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          (v52/*: any*/),
          {
            "args": (v53/*: any*/),
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      (v15/*: any*/),
                      (v13/*: any*/),
                      (v7/*: any*/),
                      (v6/*: any*/),
                      (v5/*: any*/),
                      (v27/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v33/*: any*/)
                            ]
                          },
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v40/*: any*/),
                                      (v5/*: any*/),
                                      (v13/*: any*/),
                                      (v60/*: any*/),
                                      (v61/*: any*/),
                                      (v15/*: any*/),
                                      (v62/*: any*/),
                                      (v64/*: any*/),
                                      (v7/*: any*/),
                                      (v4/*: any*/)
                                    ]
                                  },
                                  (v39/*: any*/),
                                  (v37/*: any*/),
                                  (v13/*: any*/),
                                  (v68/*: any*/),
                                  {
                                    "concreteType": "MetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "MetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "MetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v66/*: any*/),
                                              (v24/*: any*/),
                                              (v69/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v38/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v70/*: any*/),
                      (v72/*: any*/),
                      {
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "subGoals",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "concreteType": "GoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "successMeasure",
                            "plural": false,
                            "selections": [
                              (v46/*: any*/),
                              (v13/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/)
                            ]
                          },
                          (v13/*: any*/),
                          (v12/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/)
                        ]
                      },
                      {
                        "args": (v53/*: any*/),
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "successMeasures",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v72/*: any*/),
                                  (v15/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "concreteType": "GoalType",
                                    "kind": "LinkedField",
                                    "name": "goalType",
                                    "plural": false,
                                    "selections": [
                                      (v50/*: any*/),
                                      (v51/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v73/*: any*/)
                        ],
                        "storageKey": "successMeasures(first:50)"
                      },
                      (v74/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "parentGoal",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v47/*: any*/)
                ]
              },
              (v73/*: any*/)
            ],
            "storageKey": "successMeasures(first:50)"
          },
          (v77/*: any*/),
          (v15/*: any*/),
          (v72/*: any*/),
          {
            "concreteType": "MetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "MetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "MetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v47/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "Metric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v7/*: any*/),
                          (v5/*: any*/),
                          (v17/*: any*/),
                          (v40/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "externalEntityId"
                          },
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v62/*: any*/),
                          (v64/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v68/*: any*/),
                      {
                        "concreteType": "MetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TargetDate",
                                    "kind": "LinkedField",
                                    "name": "date",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TargetDateRange",
                                        "kind": "LinkedField",
                                        "name": "dateRange",
                                        "plural": false,
                                        "selections": [
                                          (v65/*: any*/),
                                          (v78/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v24/*: any*/),
                                  (v69/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v70/*: any*/),
          (v74/*: any*/),
          {
            "kind": "ScalarField",
            "name": "targetDateConfidence"
          },
          {
            "concreteType": "GoalPhaseDetails",
            "kind": "LinkedField",
            "name": "phase",
            "plural": false,
            "selections": (v79/*: any*/)
          },
          (v80/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": (v9/*: any*/)
          },
          {
            "concreteType": "GoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v75/*: any*/),
              (v56/*: any*/),
              (v81/*: any*/),
              (v83/*: any*/)
            ]
          },
          {
            "alias": "latestUpdates",
            "args": [
              (v84/*: any*/)
            ],
            "concreteType": "GoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v56/*: any*/),
                      (v85/*: any*/),
                      (v86/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "updates(first:1)"
          },
          {
            "kind": "ScalarField",
            "name": "updateStreak"
          },
          {
            "args": (v87/*: any*/),
            "concreteType": "GoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v56/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v7/*: any*/),
                          (v4/*: any*/),
                          (v52/*: any*/),
                          (v45/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canWatchGoal"
                              }
                            ]
                          },
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v4/*: any*/)
                            ]
                          },
                          (v6/*: any*/),
                          (v5/*: any*/),
                          (v18/*: any*/),
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v56/*: any*/),
                              (v75/*: any*/),
                              (v81/*: any*/),
                              (v83/*: any*/)
                            ]
                          },
                          (v80/*: any*/),
                          (v11/*: any*/),
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v13/*: any*/),
                                      (v37/*: any*/),
                                      (v88/*: any*/),
                                      {
                                        "concreteType": "MetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "MetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "MetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v78/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v24/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v72/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v13/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v5/*: any*/),
                              (v76/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v85/*: any*/),
                      (v86/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "GoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v36/*: any*/)
                                  },
                                  (v88/*: any*/),
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v36/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v71/*: any*/)
                      },
                      (v77/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": (v79/*: any*/)
                          },
                          (v13/*: any*/)
                        ]
                      },
                      (v75/*: any*/),
                      {
                        "alias": "newGoalState",
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          (v19/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v25/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v30/*: any*/)
                      },
                      (v81/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          (v4/*: any*/),
                          (v82/*: any*/),
                          (v81/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v30/*: any*/)
                      },
                      {
                        "alias": "oldGoalState",
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v26/*: any*/)
                      },
                      {
                        "concreteType": "GoalPhaseDetails",
                        "kind": "LinkedField",
                        "name": "newPhase",
                        "plural": false,
                        "selections": (v79/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": (v89/*: any*/)
                              }
                            ],
                            "type": "ProjectUpdate"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ]
                  },
                  (v57/*: any*/)
                ]
              },
              (v59/*: any*/)
            ],
            "storageKey": "updates(first:30)"
          },
          {
            "args": (v87/*: any*/),
            "handle": "connection",
            "key": "UpdatesList__updates",
            "kind": "LinkedHandle",
            "name": "updates"
          },
          {
            "args": (v41/*: any*/),
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v43/*: any*/),
              (v42/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          {
            "condition": "goalUpdateDraftsEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "DraftUpdate",
                "kind": "LinkedField",
                "name": "draftUpdate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "input"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "modifiedDate"
                  },
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "UserPII",
                        "kind": "LinkedField",
                        "name": "pii",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          (v5/*: any*/),
                          (v33/*: any*/)
                        ]
                      },
                      (v13/*: any*/)
                    ]
                  },
                  (v13/*: any*/),
                  (v42/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "keys": [
                    "GOALS_METRICS_POPUP"
                  ]
                }
              },
              (v84/*: any*/)
            ],
            "concreteType": "OnboardingConnection",
            "kind": "LinkedField",
            "name": "onboarding",
            "plural": false,
            "selections": [
              {
                "concreteType": "OnboardingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Onboarding",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v89/*: any*/)
                  }
                ]
              }
            ],
            "storageKey": "onboarding(filter:{\"keys\":[\"GOALS_METRICS_POPUP\"]},first:1)"
          },
          (v13/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "99368cb9d91659243fc7d5b3166d68ea",
    "id": null,
    "metadata": {},
    "name": "GoalViewQuery",
    "operationKind": "query",
    "text": "query GoalViewQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $goalUpdateDraftsEnabled: Boolean!\n) {\n  goal: goalByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    uuid\n    name\n    key\n    ari\n    parentGoals {\n      count\n    }\n    subGoals {\n      count\n    }\n    ...GoalArchivedPanel\n    ...GoalCompletePanel\n    ...GoalContent_okloi\n    ...useRedirectToDefaultGoalTab\n    id\n  }\n  ...metricInfoSectionNewLozenge\n}\n\nfragment ActivityHistorySection on Goal {\n  ...GoalComments\n}\n\nfragment AddToMissedUpdateMessage on Goal {\n  id\n  latestUpdates: updates(first: 1) {\n    edges {\n      node {\n        id\n        creationDate\n        missedUpdate\n        updateType\n      }\n    }\n  }\n}\n\nfragment ChangeRollupTypePopup on Goal {\n  ...ChangeRollupTypeWarning\n  id\n  goalType {\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n  progress {\n    type\n  }\n  subGoals {\n    edges {\n      node {\n        goalType {\n          kind\n          id\n        }\n        archived\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        progress {\n          type\n        }\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment ChangeRollupTypeWarning on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  goalType {\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment CompactGoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  ...progressBarMetricTarget\n  ...hasMetric\n}\n\nfragment ContributingProjectsSummary on ProjectConnection {\n  edges {\n    node {\n      archived\n      owner {\n        aaid\n        id\n      }\n      members {\n        edges {\n          node {\n            aaid\n            id\n          }\n        }\n      }\n      state {\n        value\n      }\n      id\n    }\n  }\n}\n\nfragment DraftGoalUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment DueDateContext on Goal {\n  phase {\n    name\n  }\n  latestUpdateDate\n}\n\nfragment EditGoalProgressEditor on GoalUpdate {\n  creationDate\n  goal {\n    metricTargets {\n      edges {\n        node {\n          id\n          metric {\n            id\n          }\n          metricTargetPeriods {\n            edges {\n              node {\n                date {\n                  dateRange {\n                    start\n                  }\n                }\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n          source\n          latestValue {\n            time\n            id\n          }\n        }\n        newValue {\n          value\n          id\n        }\n        newStartValue\n        newTargetValue\n      }\n    }\n  }\n}\n\nfragment EditGoalUpdate on GoalUpdate {\n  id\n  uuid\n  summary\n  newPhase {\n    name\n  }\n  newGoalState: newState {\n    score\n    value\n  }\n  newTargetDate\n  newTargetDateConfidence\n  notes {\n    summary\n    title\n    uuid\n    id\n  }\n  goal {\n    id\n    key\n    uuid\n    workspace {\n      uuid\n      id\n      aiConfig {\n        enabled\n      }\n    }\n    latestUserUpdate {\n      editDate\n      creationDate\n      summary\n      notes {\n        title\n        summary\n        id\n      }\n      id\n    }\n    metricTargets {\n      edges {\n        node {\n          metric {\n            id\n            archived\n          }\n          id\n        }\n      }\n    }\n    parentGoal {\n      uuid\n      id\n    }\n  }\n  ...EditGoalProgressEditor\n}\n\nfragment EditableGoalUpdateCard on GoalUpdate {\n  id\n  goal {\n    id\n  }\n  creationDate\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...GoalUpdateCard\n  ...EditGoalUpdate\n}\n\nfragment EmptyStateNoUpdates on Goal {\n  watching\n  canPostUpdate\n}\n\nfragment GoalAboutTab on Goal {\n  id\n  description\n  goalType {\n    kind\n    id\n  }\n  parentGoal {\n    uuid\n    id\n  }\n  capabilities {\n    canEditMetadata\n  }\n  ...GoalDescription\n  ...GoalComments\n  ...SuccessMeasuresSectionFragment\n  ...SuccessMeasureMetricSection\n  ...ActivityHistorySection\n}\n\nfragment GoalArchivedPanel on Goal {\n  id\n  state {\n    value\n  }\n}\n\nfragment GoalComments on Goal {\n  id\n  ari\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n      }\n    }\n    ...Comments\n  }\n}\n\nfragment GoalCompletePanel on Goal {\n  state {\n    value\n  }\n}\n\nfragment GoalContent_okloi on Goal {\n  key\n  ari\n  userUpdateCount\n  canEditUpdate\n  watching\n  ...GoalAboutTab\n  ...GoalUpdatesTab_okloi\n  ...GoalProjectsTab\n  ...GoalArchivedPanel\n  ...GoalCompletePanel\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalDescription on Goal {\n  id\n  uuid\n  description\n  canPostUpdate\n  workspace {\n    uuid\n    id\n  }\n  goalType {\n    kind\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        __typename\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchGoal\n  }\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProgressEditor on Goal {\n  id\n  progress {\n    percentage\n    type\n  }\n  subGoals {\n    count\n  }\n  latestUserUpdate {\n    creationDate\n    id\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n          source\n          latestValue {\n            time\n            id\n          }\n        }\n        metricTargetPeriods {\n          edges {\n            node {\n              date {\n                dateRange {\n                  start\n                }\n              }\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProjects on Goal {\n  id\n  archived\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n    ...ProjectTable\n    ...ContributingProjectsSummary\n  }\n  ...LinkGoalProject\n}\n\nfragment GoalProjectsTab on Goal {\n  goalType {\n    kind\n    id\n  }\n  projects(tql: \"archived = false\", first: 200) {\n    count\n  }\n  subGoals {\n    count\n  }\n  ...GoalProjects\n  ...GoalSubGoals\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newGoalState: newState {\n    ...GoalState\n  }\n  oldGoalState: oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalSubGoals on Goal {\n  id\n  ari\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        capabilities {\n          canAddLinkedProjects\n          canRemoveLinkedProjects\n        }\n        ...GoalSummaryPanel\n        ...CompactGoalSummaryPanel\n        ...GoalProjects\n      }\n    }\n  }\n}\n\nfragment GoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  ...progressBarMetricTarget\n  ...hasMetric\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n    ...MetricChart\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateComposer_okloi on Goal {\n  ...DueDateContext\n  ...NewGoalUpdate_okloi\n  ...AddToMissedUpdateMessage\n  draftUpdate @include(if: $goalUpdateDraftsEnabled) {\n    input\n    ...DraftGoalUpdate\n    id\n  }\n  metricTargets @include(if: $goalUpdateDraftsEnabled) {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        metric {\n          type\n          subType\n          id\n        }\n      }\n    }\n  }\n  latestUserUpdate {\n    id\n  }\n  id\n  uuid\n  workspace {\n    uuid\n    aiConfig {\n      enabled\n    }\n    id\n  }\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  missedUpdate\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newGoalState: newState {\n    value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment GoalUpdatesTab_okloi on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  targetDate\n  targetDateConfidence\n  ...GoalUpdateComposer_okloi\n  ...UpdatesList\n  draftUpdate @include(if: $goalUpdateDraftsEnabled) {\n    id\n  }\n}\n\nfragment LinkGoalProject on Goal {\n  id\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          source\n          latestValue {\n            time\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment NewGoalUpdate_okloi on Goal {\n  id\n  uuid\n  key\n  workspace {\n    uuid\n    id\n  }\n  phase {\n    name\n  }\n  state {\n    value\n    score\n  }\n  watchers {\n    count\n  }\n  latestUserUpdate {\n    id\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n  }\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  parentGoal {\n    uuid\n    id\n  }\n  ...hasMetric\n  ...GoalProgressEditor\n  draftUpdate @include(if: $goalUpdateDraftsEnabled) {\n    input\n    ...DraftGoalUpdate\n    id\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  icon {\n    id\n    shortName\n  }\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectTable on ProjectConnection {\n  edges {\n    node {\n      id\n      newPhase {\n        _id: id\n      }\n      ...ProjectTableRow\n      ...ProjectTableCompactRow\n    }\n  }\n}\n\nfragment ProjectTableCompactRow on Project {\n  id\n  key\n  name\n  state {\n    ...ProjectState\n  }\n  ...ProjectIcon\n}\n\nfragment ProjectTableRow on Project {\n  id\n  owner {\n    id\n    ...UserAvatar_2aqwkz\n  }\n  ...ProjectName_data\n  dueDate {\n    ...TargetDate\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment SuccessMeasureCardFragment on Goal {\n  ari\n  key\n  name\n  state {\n    ...GoalState\n    value\n  }\n  owner {\n    pii {\n      name\n      picture\n    }\n    id\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          name\n          id\n        }\n        targetValue\n        snapshotValue {\n          value\n          id\n        }\n        id\n      }\n    }\n  }\n  ...SuccessMeasureChart\n  ...metricInfoSectionContent\n  id\n}\n\nfragment SuccessMeasureChart on Goal {\n  id\n  metricTargets {\n    edges {\n      node {\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          values(first: 100, sort: [TIME_ASC]) {\n            edges {\n              node {\n                value\n                time\n                origin {\n                  __typename\n                  ... on FromGoalUpdate {\n                    goalUpdate {\n                      creationDate\n                      goal {\n                        id\n                      }\n                      newState {\n                        value\n                        score\n                      }\n                      id\n                    }\n                  }\n                  ... on FromMetricCreation {\n                    creationDate\n                  }\n                  ... on FromMetricUpdate {\n                    updateDate\n                  }\n                }\n                id\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n        }\n        metricValues(first: 100, sort: [TIME_ASC]) {\n          edges {\n            node {\n              time\n              id\n            }\n            metricTargetPeriod {\n              date {\n                dateRange {\n                  end\n                }\n              }\n              value\n            }\n            variance\n          }\n        }\n        metricTargetPeriods {\n          edges {\n            node {\n              date {\n                dateRange {\n                  end\n                }\n              }\n              value\n              latestValue {\n                node {\n                  value\n                  id\n                }\n                variance\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  targetDate\n}\n\nfragment SuccessMeasureMetricSection on Goal {\n  id\n  key\n  ari\n  metricTargets {\n    edges {\n      node {\n        __typename\n        id\n        ari\n        metric {\n          id\n          ari\n          name\n          type\n          subType\n          archived\n          externalEntityId\n        }\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n      }\n    }\n  }\n  ...SuccessMeasureMetricSectionEmptyState\n  ...SuccessMeasureChart\n  ...metricInfoSectionContent\n}\n\nfragment SuccessMeasureMetricSectionEmptyState on Goal {\n  ari\n}\n\nfragment SuccessMeasuresSectionFragment on Goal {\n  ari\n  archived\n  goalType {\n    kind\n    successMeasure {\n      state\n      ari\n      ...goalTypeName\n      ...goalTypeNamePlural\n      id\n    }\n    ...goalTypeName\n    id\n  }\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      __typename\n      node {\n        id\n        archived\n        ...SuccessMeasureCardFragment\n      }\n    }\n  }\n  id\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesList on Goal {\n  canEditUpdate\n  updateStreak\n  ...EmptyStateNoUpdates\n  updates(first: 30) {\n    edges {\n      node {\n        uuid\n        creationDate\n        ...EditableGoalUpdateCard\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment dropdownMenu on Goal {\n  accessLevel\n}\n\nfragment goalTypeName on GoalType {\n  name {\n    __typename\n    ... on GoalTypeCustomName {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment goalTypeNamePlural on GoalType {\n  ...goalTypeName\n  namePlural {\n    __typename\n    ... on GoalTypeCustomNamePlural {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment inlineCurrentValueUpdate on Goal {\n  id\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        metric {\n          id\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment metricInfoSectionContent on Goal {\n  id\n  ...inlineCurrentValueUpdate\n  ...progressBarMetricTarget\n  ...hasMetric\n  ...MetricChart\n  ...ChangeRollupTypePopup\n  ...dropdownMenu\n  progress {\n    type\n    percentage\n  }\n  goalType {\n    successMeasure {\n      state\n      id\n      ...goalTypeName\n      ...goalTypeNamePlural\n    }\n    id\n    kind\n  }\n  subGoals {\n    edges {\n      node {\n        progress {\n          percentage\n        }\n        goalType {\n          kind\n          id\n        }\n        archived\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        progress {\n          percentage\n          type\n        }\n        archived\n        goalType {\n          ...goalTypeName\n          ...goalTypeNamePlural\n          id\n        }\n        id\n      }\n    }\n    pageInfo {\n      hasNextPage\n    }\n  }\n  parentGoal {\n    id\n    ari\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        ari\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          ari\n          archived\n          uuid\n          name\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment metricInfoSectionNewLozenge on Query {\n  currentUser {\n    onboarding(first: 1, filter: {keys: [GOALS_METRICS_POPUP]}) {\n      edges {\n        node {\n          key\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useRedirectToDefaultGoalTab on Goal {\n  watching\n  key\n}\n"
  }
};
})();

(node as any).hash = "881b2e8cf3926a01df52560511234348";

export default node;
